module.exports = __webpack_public_path__ + "img/virtual-pos.d29565c5.png";